import { create } from 'zustand';

const useVideoGenerationStore = create((set) => ({
  activeGenerationId: null,
  generations: {},
  formData: {
    prompt_text: "",
    selectedDuration: "5s",
    selectedStyle: "None",
  },
  styles: [
    "None (Default)", "Pixar", "Ghibli", "Disney", "Realistic",
    "Anime", "Watercolor", "Oil Painting", "Sketch", "Comic",
    "3D Render", "Cyberpunk", "Fantasy"
  ],
  isFreeUser: true,
  videoCreditCost: null,
  isPublic: true,

  setIsFreeUser: (isFree) => set({ isFreeUser: isFree }),

  initializeGeneration: (generationId, data) => set((state) => ({
    generations: {
      ...state.generations,
      [generationId]: {
        ...data,
        isPublic: state.isPublic,
        status: 'generating',
        progress: 0,
        progressMessage: 'Starting generation...',
        videoUrl: null,
        error: null,
      },
    },
    activeGenerationId: generationId,
  })),

  setVideoCreditCost: (cost) => set(() => ({
    videoCreditCost: cost
  })),

  updateFormData: (data) => set((state) => ({
    formData: {
      ...state.formData,
      ...data
    }
  })),

  updateGenerationProgress: (generationId, progress, message) => set((state) => ({
    generations: {
      ...state.generations,
      [generationId]: {
        ...state.generations[generationId],
        progress,
        progressMessage: message || 'Generating video...'
      }
    }
  })),

  completeGeneration: (generationId, videoUrl) => set((state) => ({
    generations: {
      ...state.generations,
      [generationId]: {
        ...state.generations[generationId],
        status: 'completed',
        progress: 100,
        progressMessage: 'Generation complete!',
        videoUrl
      }
    }
  })),

  setGenerationError: (generationId, error) => set((state) => ({
    generations: {
      ...state.generations,
      [generationId]: {
        ...state.generations[generationId],
        status: 'error',
        error,
        progressMessage: error
      }
    }
  })),

  setPublicStatus: (status) => set({ isPublic: status }),

  clearGeneration: (generationId) => set((state) => {
    const { [generationId]: removed, ...remainingGenerations } = state.generations;
    return {
      generations: remainingGenerations,
      activeGenerationId: state.activeGenerationId === generationId ? null : state.activeGenerationId,
    };
  })
}));

export default useVideoGenerationStore; 